import type { SupportedLanguage } from '../../../i18n';
import { DEFAULT_LANGUAGE } from '../../../i18n';

import enTranslations from './en';
import zhCNTranslations from './zh-CN';
import zhTWTranslations from './zh-TW';
import jaTranslations from './ja';
import koTranslations from './ko';

export const travelTranslations = {
  en: enTranslations,
  'zh-CN': zhCNTranslations,
  'zh-TW': zhTWTranslations,
  ja: jaTranslations,
  ko: koTranslations,
} as const;

export type TravelTranslations = typeof travelTranslations;
export type TravelTranslationDictionary = TravelTranslations[keyof TravelTranslations];

export const getTravelTranslationDictionary = (language: SupportedLanguage): TravelTranslationDictionary => {
  return travelTranslations[language] ?? travelTranslations[DEFAULT_LANGUAGE];
};

export const translateTravel = (
  language: SupportedLanguage,
  key: string,
  params?: Record<string, any>,
): string => {
  const dictionary = getTravelTranslationDictionary(language);
  const segments = key.split('.');
  let value: any = dictionary;

  for (const segment of segments) {
    if (value && typeof value === 'object' && segment in value) {
      value = value[segment];
    } else {
      return key;
    }
  }

  if (typeof value !== 'string') {
    return key;
  }

  if (!params) {
    return value;
  }

  return value.replace(/\{\{(\w+)\}\}/g, (match, token) => {
    return token in params ? String(params[token]) : match;
  });
};
